import { defineStore } from 'pinia'

export type VehicleGpsState = {
  vehicles: any[]
}
export default defineStore({
  id: 'vehicleGps',
  persist: true,
  state: () => {
    return {
      vehicles: []
    } as VehicleGpsState
  },
  getters: {},
  actions: {
    clear: function () {},
    setVehicles: function (payload: any) {
      this.vehicles = payload || []
    },
    setVehicle: function (payload: any) {
      const { _id } = payload || {}
      const exists = this.vehicles.findIndex((vehicle: any) => vehicle._id === _id)
      if (exists > 0) {
        this.vehicles[exists] = payload
      } else {
        this.vehicles.push(payload)
      }
    }
  }
})
